import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAdminUser } from "./adminNavigation";
import CustomerDashboardLayout from "../../components/customer/CustomerDashboardLayout";

const AdminRouteLayout = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const content = children ?? <Outlet />;

  if (!isAdminUser(authState)) {
    return <CustomerDashboardLayout>{content}</CustomerDashboardLayout>;
  }

  return content;
};

export default AdminRouteLayout;
